import { render, staticRenderFns } from "./route-edit.vue?vue&type=template&id=467bb07b&"
import script from "./route-edit.vue?vue&type=script&lang=js&"
export * from "./route-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports